import axios from 'axios';

// Ricarico massivo del catalogo marketplace (Amazon / eBay).
// Il download passa invece dal modulo `downloads` come tutti gli altri export.

const buildUrl = (context, path) => `${context.rootGetters['settings/getUrl']}marketplacecatalog/${path}`;

const authHeader = context => ({ Authorization: `Bearer ${context.rootGetters['profile/getToken']}` });

const fail = err => {
	const detail = err?.response?.data?.error;
	return { error: Array.isArray(detail) ? detail.join(', ') : detail || err?.response?.status || true };
};

const actions = {
	// marketplace realmente usati dal profilo su quella piattaforma
	marketplaces: async (context, { platform }) => {
		return await axios
			.get(buildUrl(context, `${platform}/marketplaces`), { headers: authHeader(context) })
			.then(res => res.data)
			.catch(fail);
	},

	// carica il file e ottiene l'ANTEPRIMA: il backend non scrive ancora nulla
	preview: async (context, { platform, marketplace, file }) => {
		const form = new FormData();
		form.append('marketplace', marketplace);
		form.append('file', file);

		return await axios
			.post(buildUrl(context, `${platform}/import/preview`), form, {
				headers: { ...authHeader(context), 'Content-Type': 'multipart/form-data' },
			})
			.then(res => res.data)
			.catch(fail);
	},

	// pagine successive dell'anteprima (o righe scartate)
	rows: async (context, { platform, importId, page = 1, limit = 25, invalid = false }) => {
		return await axios
			.get(buildUrl(context, `${platform}/import/${importId}/rows`), {
				headers: authHeader(context),
				params: { page, limit, invalid: invalid ? 1 : 0 },
			})
			.then(res => res.data)
			.catch(fail);
	},

	// conferma: da qui in poi il lavoro avviene in background.
	// `excluded`: numeri di riga tolti dall'anteprima, non vengono applicati
	apply: async (context, { platform, importId, excluded = [] }) => {
		return await axios
			.post(buildUrl(context, `${platform}/import/${importId}/apply`), { excluded }, { headers: authHeader(context) })
			.then(res => res.data)
			.catch(fail);
	},
};

export default {
	namespaced: true,
	actions,
};
